module.exports = __webpack_public_path__ + "img/4.e74cbbd9.jpg";